import { Modal, ModalHeader } from "reactstrap";
import { H3, P } from "../../../../../AbstractElements";
import UpdateApplForm from "./UpdateApplForm";

interface ModalProps {
  ApplNo: string;
  modal: boolean;
  toggle?: () => void;
}

const UploadCandidateModal: React.FC<ModalProps> = ({
  ApplNo,
  modal,
  toggle,
}) => {
  return (
    <>
      <Modal
        size="xl"
        isOpen={modal}
        toggle={toggle}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="large-modal-header border-0">
            <H3>Update Applicant Information</H3>
            <button onClick={toggle} className="btn-close"></button>
            <P>
              Review and update the applicant's personal details to ensure all
              information is accurate and complete.
            </P>
          </ModalHeader>
          <UpdateApplForm ApplNo={ApplNo} toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};

export default UploadCandidateModal;
